import React from 'react';

interface VotePercentageProps {
    iVoted: boolean;
    iVotedCOA?: boolean;
    iVotedRFI?: boolean;
    voteCount: number;
    votePercentage: number;
}

  const VotePercentage: React.FC<VotePercentageProps> = ({ iVoted, iVotedCOA, iVotedRFI, voteCount, votePercentage }) => {

    return ( 
        <>
            <div className="vote-percentage">
                <div className="votes-label">Votes</div>
                <div className="votes-bar">
                    <div className="votes-bar-color" style={{ width: (votePercentage * 100) + '%' }}></div>
                </div>
                <div className="votes-percent">
                    <div className="votes-perc">{Math.round(votePercentage * 100)}%</div>
                    <div className="num-votes">{voteCount} Votes</div>
                </div>
                { iVoted || iVotedCOA || iVotedRFI ? <><div className="my-game-checked"><img src="img/green-check-shadow.svg" alt="check" className="green-vote-checked"></img></div><div className="your-vote">Your Vote</div></> : <></> }
            </div>
        </>
    )

  }

  export default VotePercentage